import { useTranslation } from 'react-i18next';
import { type AutoplayModuleSpecsFragment } from '../../../../../api/fragments/AutoplayModuleSpecs';
import {
    type CreateAutoplayModuleMutation,
    CreateAutoplayModuleDocument,
    type CreateAutoplayModuleMutationVariables,
} from '../../../../../api/mutations/createAutoplayModule';
import { type AutoplayModulePayload } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import AutoplayModulePage, { type AutoplayModulePageProps } from '../../AutoplayModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<AutoplayModuleSpecsFragment, AutoplayModulePayload> = {
    PageComponent: ({ module }: AutoplayModulePageProps) => <AutoplayModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.AutoplayModule.className'),
    getValidator: () => validators.requiredNonEmptyString('displayName'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateAutoplayModuleMutation, CreateAutoplayModuleMutationVariables>({
                mutation: CreateAutoplayModuleDocument,
                variables: {
                    companyId,
                    settings: values,
                },
            })
            .then(({ data }) => data.module),
};

export default implementation;
